import React from "react"
import {StaticQuery,Link } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import {graphql } from "gatsby"
import Pagination from "../../components/pagination"
import { Remarkable } from 'remarkable';
var md = new Remarkable();


const Medscale = () => ( 
   
    <StaticQuery query={mediumScaleIndex} render={data=>{    
     const totalPages =  data.allMarkdownRemark.pageInfo.pageCount
     const prevPage = data.allMarkdownRemark.pageInfo.hasPreviousPage
     const isLast  = data.allMarkdownRemark.pageInfo.currentPage === totalPages
     const nextPage = (data.allMarkdownRemark.pageInfo.currentPage + 1).toString()
      const path = "/medscale/";


      return (
        <div>
            <Layout>
                <SEO title="Medium Scale" />            
           
            <section id="slider" class="hero p-0 odd featured">
            <div class="swiper-container no-slider animation slider-h-50 slider-h-auto">
                <div class="swiper-wrapper">
                    <div class="swiper-slide slide-center">
                        <div class="slide-content row text-center">
                            <div class="col-12 mx-auto inner">
                                <h1 class="mb-0 title effect-static-text">Medium Scale Startups</h1>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>


        <section id="blog" class="section-1 showcase blog-grid filter-section projects">
            <div class="overflow-holder">
                <div class="container">
                    
                    <div class="row items filter-items">

                    {data.allMarkdownRemark.edges.map((tag) => {
                        return (
                        
                        <div class="col-12 col-md-6 col-lg-4 item filter-item" data-groups='["innovation","social","technology"]'>
                            
                            <div class="row card p-0 text-center">
                                <div class="image-over">
                                    <img src={tag.node.frontmatter.image} alt="Lorem ipsum"/>
                                </div>
                                <div class="card-footer d-lg-flex align-items-center justify-content-center">
                                    {/* <Link to={node.fields.slug} class="d-lg-flex align-items-center"><i class="icon-user"></i></Link> */}
                                    {/* <a href="#" class="d-lg-flex align-items-center"><i class="icon-clock"></i>2 Days Ago</a> */}
                                </div>
                                <div class="card-caption col-12 p-0">
                                    <div class="card-body">

                                        <Link to={tag.node.fields.slug}>
                                            <h4>{tag.node.frontmatter.title }</h4>
                                            <div dangerouslySetInnerHTML={{__html:md.render(tag.node.frontmatter.description).substring(0,200)}}></div>
                                        
                                        </Link>
                
                                    </div>
                                </div>
                            </div>
                        </div>  
                        
                        
                        )
                        
                        
                    })}



                    </div>
                    <Pagination
                        prevPage={prevPage} 
                        nextPage={nextPage} 
                        isFirst={1} 
                        isLast={isLast} 
                        currentPage={'1'} 
                        numPages={totalPages} 
                        path={path}
                    />  
                </div>
            </div>
        </section>
            
        </Layout>
            
            
            </div>
      )
    }}/>
    )
export const mediumScaleIndex = graphql`
  query mediumScalesQuery{
    allMarkdownRemark(filter: {fileAbsolutePath: {regex: "posts/medscale/"}} 

    ) {
      edges {
        node {
          id
          frontmatter {
            title
            description
            date
            link
            image
            city
          }
          fields{
            slug
          }
          excerpt
        }
      }
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemCount
        pageCount
        perPage
        totalCount
      }
    }
  }
  
   `

   export default Medscale